import React from 'react'
import Carrusel from '../Carrusel'
import { Link } from 'react-router-dom'

const Intro = () => {
  return (
    <div className="trama">
    <div className="grid-intro site-width">
      <div className="intro-content">
        <h1>El rincón donde <br/>el arte cobra vida</h1>
        <p>Con más de 7 años de experiencia, mi trabajo va más allá de un corte de pelo.</p>
        <div className="botones-intro">
          <Link className='reserva-button' to="/reservar">Reserva tu cita ahora</Link>
          {/*<img src="/images/los-tres-reyes-magos.svg" alt="Reyes Magos" className="papa-noel-boton" />
          <a className='wa-button' href="https://wa.me/34655790542"  rel='noreferrer' target="_blank"><img src='/images/whatsapp.svg' alt='Icono'/><p>¿Dudas? Contáctame</p></a>  */}
        </div>
      </div>
      <Carrusel />
    </div>
  </div>
  )
}

export default Intro
